module.exports = __webpack_public_path__ + "img/medicalRecord.dcba3a13.svg";